import { z } from "zod";
import { PencomConstants } from "@/constants/PencomConstants";

/** Reuses the same designation list the authorized-contact onboarding step uses. */
export const CONTACT_UPDATE_DESIGNATION_OPTIONS =
  PencomConstants.AUTHORIZED_CONTACT_ROLES;

export const EmployerContactUpdateSchema = z.object({
  name: z.string().trim().min(1, "Contact person name is required."),
  email: z.string().trim().email("Enter a valid email address."),
  designation: z
    .string()
    .min(1, "Contact person designation is required.")
    .refine(
      (value) =>
        (CONTACT_UPDATE_DESIGNATION_OPTIONS as string[]).includes(value),
      { message: "Select a valid designation." }
    ),
});
